
import { Injectable } from '@angular/core';
import {HttpClient, HttpHeaders} from "@angular/common/http";

@Injectable({
  providedIn: 'root',
})
export class HttpService {
  readonly options: any;
  constructor(readonly http: HttpClient) {
    const headers = new HttpHeaders({});
    this.options = {
      headers: headers,
    };
  }

  get<T>(url: string, options = {}) {
    return this.http.get<T>(url, options);
  }

  post<T>(url: string, payload: any, options = {}) {
    return this.http.post<T>(url, payload, options);
  }

  put<T>(url: string, payload: any, options = {}) {
    return this.http.put<T>(url, payload);
  }

  patch<T>(url: string, payload: any, options = {}) {
    return this.http.patch<T>(url, payload, options);
  }

  delete<T>(url: string, options = {}) {
    return this.http.delete<T>(url, options);
  }

  deleteWithBody(url: string, data: any) {
    return this.http.delete(url, {
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: data,
    });
  }
}
